import { BlueprintInstanceType } from '@rta/rta-blueprint-library';

import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';

export const customAppliancePropertiesMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: 'Custom Appliance Properties',
		onClick: ({ context, controller }): void => {
			controller.publishShowProperties('custom-appliance', context.id);
		},
		isVisible: ({ refMap }): boolean => {
			// const { ui } = appState;
			// const refEntry = controller?.kitchen?.getReferenceMap(ui.pointer.context.ref.id);

			// Don't continue if we are not dealing with a PanelItem
			if (refMap?.type !== BlueprintInstanceType.PanelItem) return false;

			return refMap.panelItem.item.sku === 'CUSTOM';
		}
	};
};
